// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sKP2w","title":"styles_title__3so1X"};